import styled from 'styled-components';

export const AppearanceStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  input[type='color'] {
    height: 26px;
    width: 26px;
    border: 1px solid gray;
    border-radius: 4px;
  }
  #time-graphics {
    padding-right: 0;
  }
  .preview-header {
    background: #333;
    color: #fff;
    padding: 8px;
    text-align: center;
  }
  .preview-content {
    padding: 1rem;
  }
  .inline-grid-2 {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .pd-bottom-2 {
    padding-bottom: 2px;
  }
  .pd-top-8 {
    padding-top: 8px;
  }
`;
